import React, { useState } from "react";
import './Upload.css';
import Navbar from '../Navbar/Navbar';
import axios from 'axios';
import Pool from '../../UserPool'

export const Upload = (props) => {
    const [name, setName] = useState('');
    const [university, setUniversity] = useState('');
    const [course, setCourse] = useState('');
    const [selectedFile, setSelectedFile] = useState('');
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [uploaded, setUploaded] = useState('');
    const [fileData, setFileData] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        university: '',
        course: '',
        selectedFile: '',
        file: '',
        fileName: '',
        thumbnail: '',
        fileType: '',
    })

    let accessToken = null;
    let userSub = null;
    const user = Pool.getCurrentUser();
    if (user) {
        user.getSession((err, session) => {
            if (err) {
                return
            } else {
                accessToken = session.getAccessToken().getJwtToken();
                user.getUserAttributes((err, result) => {
                    // console.log('user attributes', result);
                    userSub = result[0]['Value'];
                });
            }
        })
    } else {
        console.error("user not found")
    }

    function onFileChange(event) {
        event.preventDefault();
        setFile(event.target.files[0]);
        setFileType(event.target.files[0].type);
        setFileName(event.target.files[0].name);
       
        console.log(event.target.files[0].name);
    }

    const getFilesInfo = () => {
        let path = `https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/get-file-names?&uni=${university}&course=${course}&file=${fileName}`
        fetch(path, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
//                 'authorization': accessToken,
            },
        })
            .then(response => response.json())
            .then(response => {
                console.log(response);
                const fileDetails = response.map(fileDetail => (
                    <div className="upload-card" >
                        <a className='upload-card-download' href={`https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/file-download?file=${fileDetail['file_name']}`}>
                            <img className="upload-card-thumbnailImage" src={`https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/thumbnail-download?file=${fileDetail['file_name']}`} alt="icons" />
                            <h2>{fileDetail['file_name']}</h2>
                        </a>
                        <p>{fileDetail['university']}</p>
                        <p>{fileDetail['course']}</p>

                    </div>
                ));
                setFileData(fileDetails);
            })
    }

    const onFileUpload = (event) => {
        event.preventDefault();
        setUploaded('');
        console.log("in file upload");

        let path = `https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/file-upload?file=${fileName}&uni=${university}&course=${course}&user=${userSub}`;
        axios.post(path, file, {
            "Access-Control-Allow-Origin": "*",
        })
        .then(() => {
            setFile(null);
            console.log('sent form data')
            console.log(fileType);

            setUploaded(<div id="uploaded"> <h1>File Uploaded!</h1></div>);
            getFilesInfo();
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    }
    return (
        // body
        <div>
            {/* top bar */}
            <Navbar />
            <div>
                <form className="upload-form" onSubmit={handleSubmit}>
                    <div className="flex-container">
                        <div className="flex-child">
                            {/*<label className="upload-labels" htmlFor="name">Document Name:</label>
                            <br />
                            <input value={fileName} onChange={(e) => setFileName(e.target.value)} type="text" id="name" className="upload-input" />
                            <br />
                            <br />
                            */}
                            <label className="upload-labels" htmlFor="university">University:</label>
                            <br />
                            <input value={university} onChange={(e) => setUniversity(e.target.value)} type="text" className="upload-input" />
                            <br />
                            <br />
                            <label className="upload-labels" htmlFor="course">Course:</label>
                            <br />
                            <input value={course} onChange={(e) => setCourse(e.target.value)} type="text" className="upload-input" />
                        </div>

                        <div className="flex-child">
                            <label className="upload-labels" htmlFor="Upload">Choose Your File (pdf only):  </label>
                            <input type="file" accept=".pdf" onChange={onFileChange} />
                            <br />
                            <div className="upload-button-container">
                                <button className="button upload-button" onClick={onFileUpload}>Upload</button>
                            </div>
                            {/* <br />
                            <label className="upload-labels" for="selected-file">Selected File:</label>
                            <br />
                            <input value={selectedFile} onChange={(e) => setSelectedFile(e.target.value)} type="text" className="upload-filename" disabled />
                            <br />
                            <br />
                            <br />
                            <button className="button" type="submit">Submit</button> */}
                        </div>
                    </div>
                </form>
                {uploaded}
                <div class="card-container">
                    {fileData}
                </div>
            </div>

        </div>
    )
}
export default Upload;
